export enum SRMatchStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  MATCHES_FOUND = 'MATCHES_FOUND',
  MATCHING_COMPLETED = 'MATCHING_COMPLETED',
  NO_MATCHES_FOUND = 'NO_MATCHES_FOUND',
}

export enum SRMatchStatusLabels {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  MATCHES_FOUND = 'Matches Found',
  MATCHING_COMPLETED = 'Matching Completed',
  NO_MATCHES_FOUND = 'No Matches Found',
}


